import api from "./api";
import axios from "axios";

const comprobanteService = {
    getComprobanteView: async (idComprobante) => {
        const response = await api.get("/Comprobante/GetComprobanteView?idComprobante=" + idComprobante);
        return response;
    },

    getsComprobanteDetalleView: async (idComprobante) => {
        const response = await api.get("/Comprobante/GetsComprobanteDetalleView?idComprobante=" + idComprobante);
        return response;
    },

    getsComprobanteResumenViewFilter: async (filters) => {
        const response = await api.get("/Comprobante/GetsComprobanteResumenViewFilter", { params: filters });
        return response;
    },

    addComprobante: async (comprobante) => {
        const response = await api.post("/Comprobante/AddComprobante", comprobante);
        return response;
    },

    addUpdateComprobanteWithDetails: async (comprobante) => {
        const response = await api.post("/Comprobante/AddUpdateComprobanteWithDetails", comprobante);
        return response;
    },

    annulComprobante: async (idComprobante) => {
        const response = await api.post("/Comprobante/AnnulComprobante?idComprobante=" + idComprobante);
        return response;
    },

    activeComprobante: async (idComprobante) => {
        const response = await api.post("/Comprobante/ActiveComprobante?idComprobante=" + idComprobante);
        return response;
    },

    getTipoCambio: async (moneda) => {
        const response = await axios.get("https://api.frankfurter.dev/v2/rates?base=" + moneda + "&quotes=PEN");
        return response;
    }
};

export default comprobanteService;
